import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useCommentsFeed } from './useCommentsFeed';

export const useRefreshCommentsFeed = () => {
  const { pathname } = useLocation();

  const { getCommentsFeedItems } = useCommentsFeed();

  const refreshCommentsFeed = useCallback(() => {
    if (pathname !== '/admin/comments') {
      return;
    }

    getCommentsFeedItems();
  }, [getCommentsFeedItems, pathname]);

  return { refreshCommentsFeed };
};
